import { isNumber } from 'lodash';
import { IHistoricalPerformanceChartData } from './HistoricalPerformanceChart';
import { formatInTimeZone } from 'date-fns-tz';
import { DEFAULT_DATE_TIME_FORMAT_WITHOUT_ZONE, getComputerFormattedTime } from '../../../domain/date/date';

export function renderTooltip(item: IHistoricalPerformanceChartData, timezone: string) {
    const date = `${formatInTimeZone(item.eventStart, timezone, DEFAULT_DATE_TIME_FORMAT_WITHOUT_ZONE)} ${getComputerFormattedTime(new Date(), 'zzz')}`;

    const nominationKw = item.nominationKw;
    const performanceKw = item.performanceKw;
    const performancePercentage = isNumber(performanceKw) && isNumber(nominationKw) && nominationKw > 0 ? performanceKw / nominationKw : null;
    let shortfall = 0; // Represents how many more kW we need to reach the 100%

    if (isNumber(performanceKw) && isNumber(nominationKw) && Math.round(performanceKw) < Math.round(nominationKw)) {
        shortfall = Math.round(nominationKw) - Math.round(performanceKw);
    }

    const formattedNomination = isNumber(nominationKw) ? `${new Intl.NumberFormat('en-EN').format(Math.round(nominationKw))} kW` : 'N/A';
    const formattedPerformanceKw = isNumber(performanceKw) ? `${new Intl.NumberFormat('en-EN').format(Math.round(performanceKw))} kW` : 'N/A';
    const formattedPerformancePercentage = isNumber(performancePercentage)
        ? `${new Intl.NumberFormat('en-EN').format(Math.round(performancePercentage * 100))} %`
        : 'N/A';

    const dateElement = date ? `<div style='text-align: center; color: #697475; padding: 0 10px;'>${date}</div>` : '';
    const dividerElement = `<div style='margin: 10px 0 10px 0; height: 1px; border-bottom: 1px solid #f0f0f0;'></div>`;

    return `<div style='padding: 10px 0; margin: 0;'>
                ${dateElement}
                ${dividerElement}
                ${makeSeriesElement('Nomination', 'rgba(187, 195, 195, 1)', 'solid', formattedNomination)}
                ${makeSeriesElement('Performance', '#238c8b', 'solid', formattedPerformanceKw)}
                ${makeSeriesElement('Performance %', 'rgba(0, 0, 0, 0)', 'solid', formattedPerformancePercentage)}
                ${shortfall ? makeSeriesElement('Shortfall', 'rgba(0, 0, 0, 0)', 'solid', `${new Intl.NumberFormat('en-EN').format(shortfall)} kW`) : ''}
                ${dividerElement}
                ${makeSeriesElement('Event duration', 'rgba(0, 0, 0, 0)', 'solid', `${item.eventDuration} m`)}
                ${item.meters > 1 ? makeSeriesElement('Meters', 'rgba(0, 0, 0, 0)', 'solid', `${item.meters}`) : ''}
            </div>`;
}

function makeSeriesElement(name: string, color: string, style: 'dashed' | 'solid', value: any) {
    return `<div style='padding: 0 10px; display: flex; justify-content: space-between; color: #2e3838; font-size: 14px; font-weight: 400'>
                    <div style='display: flex; justify-content: center; align-items: center; padding-right: 8px'>
                        <span style='display: inline-block; width: 20px; line-height: 14px; border-bottom: 4px ${style} ${color}'></span> 
                        <span style='padding-left: 4px'>${name}:</span>
                    </div>
                    <div style='align-self: flex-end'>${value}</div>
                </div>`;
}
